import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import TranslationsService from "@/services/translations.ts";
import { useAuthStore } from "@/stores";
import InviteUserApiRequest from "@/models/requests/InviteUserApiRequest";
import AdminUpdateUserApiRequest from "@/models/requests/AdminUpdateUserApiRequest";

export const useIdentityManagementStore = defineStore("identityManagement", {
  state: () => ({
    error: "" as any,
  }),
  actions: {
    async inviteUser(request: InviteUserApiRequest) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);
      if (!isAuthenticated.value) return;

      const locale = TranslationsService.getUserLocale();
      await api
        .post(`v1.0/users/invite?culture=${locale.locale}`, request)
        .catch((error) => (this.error = error));
    },
    async adminUpdateUser(request: AdminUpdateUserApiRequest) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);
      if (!isAuthenticated.value) return;

      await api
        .post(`v1.0/users/manage/update`, request)
        .catch((error) => (this.error = error));
    },
  },
});
